export const ACCORDION_DEFAULTS = {
  gap: '0px',
  borderRadius: '0px',
  borderWidth: '0px 0px 1px 0px',
  borderColor: '#efefef',
  borderStyle: 'solid',
  padding: '0px',
  background: 'transparent',
  boxShadow: 'unset',
  arrowColor: '#000000',
};
